import {AbstractControl, ValidatorFn} from '@angular/forms';
import {SystemPreferences} from "../entities/system-preferences";

export class UserValidators {
    static abc(): ValidatorFn {
        console.log("Started validation");

        return (c: AbstractControl) => {

            let isValid = c.value === 'Juri';

            console.log(isValid);
            console.log(c);

            if (isValid) {
                return null;
            } else {
                return {
                    juriName: {
                        valid: false
                    }
                };
            }
        }
    }

    static passwordLength(systemPreferences: SystemPreferences) {
        return (control: AbstractControl) => {
            let length = control.value.length;
            let minimum = systemPreferences.password_length_minimum;
            let maximum = systemPreferences.password_length_maximum;

            if ( length < minimum || length > maximum ) {
                return {
                    passwordLength: {
                        minimum: minimum,
                        maximum: maximum,
                        actual: length
                    }
                }
            }

            return null;
        }
    }
}



// WEBPACK FOOTER //
// ./src/app/validators/user.validators.ts